import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { StorefrontProvider } from './context/StorefrontContext';
import './index.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <StorefrontProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </StorefrontProvider>
  </StrictMode>,
);
